<sc-title>
  <sc-dictionary-label dictionaryKey="tmc.admin.yard-structure.stationgroup-details.title"></sc-dictionary-label>
</sc-title>
<sc-content-spacer vertical></sc-content-spacer>
<div class="mask">
  @if (stationGroup != null) {
    <sc-flex vertical stretchContent>
      <mat-form-field class="stationGroupProperty" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc.stationgroup.name"></sc-dictionary-label>
        </mat-label>
        <input [(ngModel)]="stationGroup.name" #ctrl="ngModel" name="stationGroupName" matInput [required]="true"
          [maxlength]="255" />
        </mat-form-field>
        <sc-content-spacer vertical></sc-content-spacer>
        <mat-form-field class="stationGroupProperty" appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.station-group.station-group-type"></sc-dictionary-label>
          </mat-label>
          <mat-select [(ngModel)]="stationGroup.stationGroupType" name="stationGroupType">
            @for (o of stationGroupTypes; track o) {
              <mat-option value="{{o}}">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.station-group.station-group-type.{{o}}"></sc-dictionary-label>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <sc-content-spacer vertical></sc-content-spacer>
        <mat-form-field class="stationGroupProperty" appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc.stationgroup.externalKey"></sc-dictionary-label>
          </mat-label>
          <input [(ngModel)]="stationGroup.externalKey" name="{{'stationGroupExternalKey' }}" matInput
            #sgExternalKeyCtrl="ngModel" [required]="true" [maxlength]="50" [minlength]="1" />
          </mat-form-field>
          <sc-content-spacer vertical></sc-content-spacer>
          <mat-form-field class="stationGroupProperty" appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc.stationgroup.description"></sc-dictionary-label>
            </mat-label>
            <textarea [(ngModel)]="stationGroup.description" name="{{'stationGroupDescription' }}" matInput [required]="false"
            [maxlength]="255"></textarea>
          </mat-form-field>
        </sc-flex>
      }
    </div>
